import {BookingService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        courseTimes: [],
        periods: [],
        booked: [],
        drew:[],
        availablePeriodsInRange: [],
        availableDrawablePeriodsInRange: {},
    },
    getters: {
        usedTimes(state) {
            return state.courseTimes.filter(c => c.periods.length > 0);
        }
    },
    mutations: {
        saveCourseTimes(current, times) {
            current.courseTimes.splice(0);
            current.courseTimes = [...times];
        },

        savePeriods(current, periods) {
            current.periods.splice(0);
            current.periods.push(...periods);
        },
        saveAvailablePeriodsInRange(current, periods) {
            current.availablePeriodsInRange.splice(0);
            current.availablePeriodsInRange = [...periods];
        },

        saveAvailableDrawablePeriodsInRange(current, periods) {
            current.availableDrawablePeriodsInRange = {...periods};
        },

        addNewBooked(current, booked) {
            current.booked.push(...booked);
        },

        saveBooked(current, booked) {
            current.booked.splice(0);
            current.booked = [...booked];
        },
        saveDrew(current, drew) {
            current.drew.splice(0);
            current.drew = [...drew];
        }
    },
    actions: {
        async getCourseTimesAction({ commit}) {
            await bindLoading(commit,
                async () => commit('saveCourseTimes', await BookingService.getCoursesTimeOfPE()), 'booking')
        },
        async getPeriodsAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('savePeriods', await BookingService.getPeriods()), 'booking')
        },

        async submitNormalFormAction({dispatch, commit}, formData) {
            return await bindLoading(commit, async () => {
                const {success, instance, messages} = await BookingService.submitNormalForm(formData);
                if (success) {
                    commit('addNewBooked', instance);
                } else {
                    //refresh data
                    dispatch('getBookedEventsAction', formData.roomId);
                    dispatch('getAvailablePeriodsInRangeAction', {
                        range : formData.range,
                        roomId : formData.roomId
                    });
                }
                return {success, messages};
            }, 'booking')
        },

        async submitDrawableFormAction({dispatch, commit}, formData) {
            return await bindLoading(commit, async () => {
                const {success, messages} = await BookingService.submitDrawableForm(formData);
                return {success, messages};
            }, 'booking')
        },

        async getAvailablePeriodsInRangeAction({ commit}, checking) {
            await bindLoading(commit,
                async () => commit('saveAvailablePeriodsInRange',
                    await BookingService.getAvailablePeriods(checking)), 'booking'
                );
        },

        async getAvailablePeriodsInRangeSuperAction({ commit}, checking) {
            await bindLoading(commit,
                async () => commit('saveAvailablePeriodsInRange',
                    await BookingService.getAvailablePeriodsSuper(checking)), 'booking'
            );
        },

        async getAvailableDrawablePeriodsInRangeAction({ commit}, checking) {
            await bindLoading(commit,
                async () => commit('saveAvailableDrawablePeriodsInRange',
                    await BookingService.getAvailableOfDrawable(checking)), 'booking'
            );
        },

        async getBookedEventsAction({ commit}, roomId){
            await bindLoading(commit,
                async () => commit('saveBooked', await BookingService.getEvents(roomId)), 'booking')
        },

        async getDrewEventsAction({ commit}, {roomId, month}){
            await bindLoading(commit,
                async () => commit('saveDrew', await BookingService.getEventsOfDrew({roomId, month})), 'booking')
        }
    }
}